export default "__VITE_ASSET__6SaEpuak__"